import { render, staticRenderFns } from "./RolePictureView.vue?vue&type=template&id=b2653960&scoped=true"
import script from "./RolePictureView.vue?vue&type=script&lang=js"
export * from "./RolePictureView.vue?vue&type=script&lang=js"
import style0 from "./RolePictureView.vue?vue&type=style&index=0&id=b2653960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2653960",
  null
  
)

export default component.exports